import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { markSectionItemComplete } from '@/lib/markSectionItemComplete';

export function useSectionItemCompletion(
  sectionItemId: string | undefined,
  courseId: string | undefined,
  enabled = true,
) {
  const markedRef = useRef(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!enabled || !sectionItemId) return;

    markedRef.current = false;

    const markComplete = async () => {
      if (markedRef.current) return;
      markedRef.current = true;
      try {
        await markSectionItemComplete(sectionItemId, { courseId, queryClient });
      } catch {
        markedRef.current = false;
      }
    };

    void markComplete();
  }, [courseId, enabled, queryClient, sectionItemId]);
}
